import React from 'react';
import {
  INTL_MARKETS,
  useConditionalFeature,
} from '@americanexpress/conditional-features';
import SearchRow from '../SearchRow/SearchRow';
import FilterRow from '../FilterRow/FilterRow';
import OptionsRow from '../OptionsRow/OptionsRow';

const PackagesSearchBody = () => {
  const hasOptionsRow = useConditionalFeature(INTL_MARKETS);
  return (
    <div
      className="pad"
    >
      <FilterRow />
      <SearchRow />
      {hasOptionsRow && <OptionsRow />}
    </div>
  );
};

export default PackagesSearchBody;
